import React from "react";

const MeBusinessPortalLogo = ({ fillColor }) => {
    const svgFill = fillColor ?? "#FFFFFF";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="212"
            height="30"
            viewBox="0 0 212 22.895"
        >
            <g id="Group_5940" data-name="Group 5940" transform="translate(-28 -28)">
                <path
                    id="Path_1491"
                    data-name="Path 1491"
                    d="M-30-37.207h-1.626v4.438c0,2.417-1.011,3.823-2.725,3.823s-2.417-1.1-2.417-2.637c0-2.812.483-6.811.483-9.448,0-4.35-2.373-7.514-8.042-7.514-4.219,0-7.251,1.186-8.7,4.57-.747-2.812-2.9-4.526-7.558-4.526-4.219,0-6.987,1.1-8.437,3.955-.571-2.681-2.461-3.955-6.2-3.955-3.076,0-5.581,1.186-6.2,1.934,1.89.879,2.2,1.846,2.2,4.658l-.044,15.82H-68.5V-38.438c0-4.394,1.318-6.2,3.208-6.2,1.538,0,2.153.879,2.153,2.812v15.732h10.766v-12.3c0-4.922,1.538-5.845,3.164-5.845,1.318,0,2.065.879,2.065,2.461,0,1.977-.4,5.581-.4,7.471,0,6.02,3.208,8.657,9.4,8.657,5.01,0,8.13-2.417,8.13-7.295ZM-7.808-33.78C-8.6-30.308-10.8-27.8-15.147-27.8c-3.164,0-4.966-1.186-5.537-5.713,8.965-.7,13.227-3.6,13.227-8.393,0-4.087-3.164-6.592-9.756-6.592-8.789,0-14.414,4.438-14.414,11.382,0,6.723,4.7,11.469,14.37,11.469,7.514,0,10.283-3.823,11.074-8.13ZM-17.916-46.392c1.494,0,2.461.923,2.461,4.35v1.011c.044,3.252-1.23,4.878-3.735,5.361l-1.626.308-.044-1.714C-20.86-44.458-20.069-46.392-17.916-46.392Z"
                    transform="translate(109.415 76.545)"
                    style={{ fill: svgFill }}
                />
                <text
                    id="Me_Business_Portal"
                    data-name="Me Business Portal"
                    transform="translate(119 45)"
                    style={{ fill: svgFill }}
                    fontSize="16"
                    fontFamily="Manrope-Medium, Manrope"
                    fontWeight="500"
                >
                    <tspan x="0" y="0">Business Portal</tspan>
                </text>
            </g>
        </svg>
    );
};

export default MeBusinessPortalLogo;